'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _export = require('./export.js');

var gen = require('./gen.js');

var _import = require('./import.js');

var info = require('./info.js');

var list = require('./list.js');

var rename = require('./rename.js');

var rm = require('./rm.js');

var KeyAPI = function KeyAPI(_ref) {
  var keychain = _ref.keychain;

  _classCallCheck(this, KeyAPI);

  this.gen = gen.createGen({
    keychain: keychain
  });
  this.list = list.createList({
    keychain: keychain
  });
  this.rm = rm.createRm({
    keychain: keychain
  });
  this.rename = rename.createRename({
    keychain: keychain
  });
  this.export = _export.createExport({
    keychain: keychain
  });
  this.import = _import.createImport({
    keychain: keychain
  });
  this.info = info.createInfo({
    keychain: keychain
  });
};

exports.KeyAPI = KeyAPI;